import { createReducer } from 'redux-act';
import * as actions from '#app/actions/activeMultiPayment';
import type { ActiveMultiPaymentFormPayload } from '#app/actions/activeMultiPayment';

export interface ActiveMultiPaymentState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: ActiveMultiPaymentState = {
  modalVisible: false,
  form: {},
};

const setActiveMultiPaymentModalVisible = (
  state: ActiveMultiPaymentState,
  bool: boolean
): ActiveMultiPaymentState => ({
  ...state,
  modalVisible: bool,
});

const setActiveMultiPaymentForm = (
  state: ActiveMultiPaymentState,
  form: ActiveMultiPaymentFormPayload
): ActiveMultiPaymentState => ({
  ...state,
  form: form ?? {},
});

export default createReducer<ActiveMultiPaymentState>(
  {
    [actions.setActiveMultiPaymentModalVisible.getType()]: setActiveMultiPaymentModalVisible,
    [actions.setActiveMultiPaymentForm.getType()]: setActiveMultiPaymentForm,
  },
  initialState
);
